/**
 * API endpoint names for @tc/http contract decorators.
 * These map to the endpoint values defined in environments/endpoints.ts
 *
 * Usage:
 * @ApiContract({ endpoint: Api.getAccount, httpMethod: HttpMethods.get })
 * export class ApiGetAccount { ... }
 */
export class Api {
  // Account Management
  static readonly createAccount = 'CreateAccount';
  static readonly getAccount = 'GetAccount';
  static readonly updateAccount = 'UpdateAccount';
  static readonly setAlias = 'SetAlias';
  static readonly checkSuspension = 'CheckSuspension';

  // Account Validation
  static readonly validateAlias = 'ValidateAlias';
  static readonly validateEmail = 'ValidateEmail';
  static readonly validateUsername = 'ValidateUsername';
  static readonly getPasswordStrength = 'GetPasswordStrength';
  static readonly getPhoneNumberValidation = 'GetPhoneNumberValidation';

  // Authentication
  static readonly authorize = 'authorize';
  static readonly logoff = 'logoff';
  static readonly refresh = 'refreshtoken';
  static readonly getToken = 'GetToken';
  static readonly submitPhotoVerification = 'SubmitPhotoVerification';

  // Payment Methods
  static readonly addPaymentMethod = 'AddPaymentMethod';
  static readonly removePaymentMethod = 'RemovePaymentMethod';
  static readonly updateDefaultPaymentMethod = 'UpdateDefaultPaymentMethod';

  // Wallet
  static readonly getWallet = 'GetOrCreateWallet';
  static readonly addFabalFunds = 'AddFabalFunds';

  // Email Notifications
  static readonly getEmailNotifications = 'GetEmailNotification';
  static readonly updateEmailNotifications = 'UpdateEmailNotification';

  // API Clients
  static readonly getApiClients = 'GetApiClients';
  static readonly createClient = 'CreateClient';
  static readonly toggleClient = 'ToggleClient';
  static readonly resetClientPassword = 'ResetClientPassword';
  static readonly forgotClientPassword = 'SendForgotPassword';

  // Auctions & Bidding
  static readonly getAuction = 'GetAuction';
  static readonly getAuctions = 'GetAuctions';
  static readonly getAuctionBidHistory = 'GetAuctionBidHistory';
  static readonly getAuctionSummary = 'GetAuctionSummary';
  static readonly getFallbackAuctionData = 'GetRecentAuctions';
  static readonly placeBid = 'PlaceBid';
  static readonly bulkPlaceBid = 'BulkPlaceBid';

  // Private Seller (Selling Auctions)
  static readonly getPrivateSellerItems = 'GetPrivateSellerItems';
  static readonly startPrivateSellerAuction = 'StartPrivateSellerAuction';
  static readonly updatePrivateSellerItem = 'UpdatePrivateSellerItem';
  static readonly cancelPrivateSellerItem = 'CancelPrivateSellerItem';
  static readonly uploadPrivateSellerFile = 'UploadPrivateSellerFile';
  static readonly uploadPrivateSellerText = 'UploadPrivateSellerText';

  // Backorders
  static readonly upsertBackordersByDomainName = 'UpsertBackordersByDomainName';
  static readonly cancelBackorder = 'CancelBackorders';
  static readonly getBackorderPolicies = 'GetBackorderPolicies';

  // Cart & Checkout
  static readonly getCart = 'GetCart';
  static readonly placeOrder = 'PlaceOrder';

  // Search
  static readonly search = 'Search';
  static readonly filters = 'Filters';
  static readonly myAccountSearch = 'MyAccountSearch';

  // Saved Searches
  static readonly saveSearch = 'SaveSearch';
  static readonly findSavedSearches = 'findSavedSearches';
  static readonly deleteSearch = 'deleteSearch';
  static readonly updateSearchName = 'updateSearchName';

  // Domain Details
  static readonly getDomainDetail = 'GetDomainDetail';

  // Purchase History
  static readonly buyingHistorySearch = 'History/Search';
  static readonly buyingHistoryFilters = 'History/Filters';
  static readonly buyingHistoryDownload = 'History/Download';
  static readonly buyingHistoryReceipt = 'GetPurchaseReceiptByReferenceId';

  // Purchase Receipts
  static readonly getPurchaseReceipt = 'GetPurchaseReceipt';
  static readonly getPurchaseReceipts = 'GetPurchaseReceipts';
  static readonly purchaseReceiptsDownload = 'PurchaseReceipts/Download';
  static readonly invoiceReceiptsDownload = 'Invoice/Download';

  // Utilities
  static readonly getCountries = 'GetCountries';
  static readonly getCountry = 'GetCountry';
  static readonly getFileUrl = 'GetFileUrl';
  static readonly getMilliseconds = 'GetMilliseconds';
  static readonly checkRateLimit = 'CheckRateLimit';

  // Legal & Contact
  static readonly legalDocs = 'GetLegalDoc';
  static readonly contactUs = 'ContactUs';
  static readonly getGlobalNotifications = 'GetGlobalNotifications';

  // Download
  static readonly getHistoryDownload = 'DownloadHistory';
}
